import { Injectable, OnDestroy } from '@angular/core';
import { BaseStoreFacade, BusinessRegionFacade, CityPersistenceState } from '@city/data-access';
import { StatePersistenceService } from '@spartacus/core';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { CityService } from './city.service';

@Injectable({ providedIn: 'root' })
export class CityStatePersistenceService implements OnDestroy {
  protected subscription = new Subscription();

  constructor(
    private statePersistenceService: StatePersistenceService,
    private businessRegionFacade: BusinessRegionFacade,
    private baseStoreFacade: BaseStoreFacade,
    private cityService: CityService,
  ) {}

  sync(): void {
    this.subscription.add(
      this.statePersistenceService.syncWithStorage({
        key: 'city',
        state$: this.getCityState(),
        onRead: (state) => this.onRead(state),
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onRead(state: CityPersistenceState): void {
    this.cityService.onReadCityState(state);
  }

  private getCityState(): Observable<CityPersistenceState> {
    return combineLatest([
      this.baseStoreFacade.getActiveCode(),
      this.businessRegionFacade.getNoDeliveryIsShowing(),
      this.businessRegionFacade.getBusinessRegion(),
    ]).pipe(
      map(([activeBaseStore, noDeliveryIsShowing, businessRegion]) => ({
        businessRegion,
        noDeliveryIsShowing,
        activeBaseStore,
      })),
    );
  }
}
